import { useQuery } from "@tanstack/react-query";
import { ProviderGroupControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  providerGroupName?: string;
}

/**
 *
 * @author [Atish Bagate]
 */
export const useGetConfigurationDetailsByName = ({
  providerGroupName,
}: Props): useBaseContent<any> => {
  return useQuery({
    queryKey: ["configuration-details-by-name", providerGroupName],
    queryFn: async () =>
      await new ProviderGroupControllerApi(getConfigObject())
        .getProviderGroupConfig(
          providerGroupName!,
          getXtenantId() ?? providerGroupName // xTENANTID
        )
        .then((res) => res?.data),
  });
};
